function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon/Big/TwoDrops"
}, React.createElement("path", {
  id: "Combined Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.90244 41.6218C1.90244 28.3294 24.3969 6.20961 28.5366 2.25181C32.6763 6.20961 55.1707 28.3294 55.1707 41.6218C55.1707 56.227 43.2225 68.108 28.5366 68.108C13.8507 68.108 1.90244 56.227 1.90244 41.6218ZM0 41.6218C0 57.2695 12.8015 69.9999 28.5366 69.9999C44.2717 69.9999 57.0732 57.2695 57.0732 41.6218C57.0732 26.2361 30.323 1.30776 29.1844 0.253984C28.8191 -0.0846615 28.2541 -0.0846615 27.8888 0.253984C26.7502 1.30776 0 26.2361 0 41.6218ZM46.8219 69.8799C47.6979 69.9593 48.5873 70 49.4634 70C65.1985 70 78 57.2696 78 41.6219C78 26.2362 51.2498 1.30785 50.1112 0.254079C49.7459 -0.0845669 49.1809 -0.0845669 48.8156 0.254079L48.813 0.256562C48.7061 0.35587 45.6562 3.19035 41.6729 7.41956C41.3134 7.80077 41.3333 8.39955 41.7167 8.75617C42.0991 9.11279 42.7012 9.09293 43.0617 8.71266C45.9648 5.62985 48.3629 3.3 49.4625 2.2519C53.6003 6.20687 76.0976 28.3286 76.0976 41.6219C76.0976 56.2262 64.1493 68.1081 49.4634 68.1081C48.6444 68.1081 47.814 68.0703 46.9959 67.9956C46.469 67.9483 46.0095 68.3314 45.962 68.8516C45.9135 69.3719 46.2987 69.8316 46.8219 69.8799Z",
  fill: "#6E6E6E"
}));

var SvgTwoDrops = function SvgTwoDrops(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwoDrops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/two-drops.40b6edf6.svg";
export { ForwardRef as ReactComponent };